var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full px-5"},[_c('div',{staticClass:"mx-auto max-w-gw-wrapper pt-4 md:pt-6"},[_c('ContentsAssembly',{staticClass:"min-h-50vh"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }